import React from "react";
import { CalendarPlus } from "lucide-react";

const z = (d) => new Date(d).toISOString().replace(/[-:]/g, "").replace(/\.\d{3}Z$/, "Z");

export const AddToCalendar = ({ icsUrl, title, start, end, durationMin = 60, location = "", details = "", testid = "add-to-calendar" }) => {
  if (!start) return null;
  const s = new Date(start);
  const e = end ? new Date(end) : new Date(s.getTime() + durationMin * 60000);
  const google = `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(title)}&dates=${z(s)}/${z(e)}&details=${encodeURIComponent(details)}&location=${encodeURIComponent(location)}`;
  const cls = "inline-flex items-center gap-1.5 h-9 px-3 rounded-full border text-xs font-medium hover:bg-muted transition-colors";
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid={testid}>
      <span className="text-xs text-muted-foreground inline-flex items-center gap-1"><CalendarPlus className="h-3.5 w-3.5" />Add to calendar:</span>
      <a className={cls} href={icsUrl} data-testid={`${testid}-apple`}>Apple</a>
      <a className={cls} href={google} target="_blank" rel="noreferrer" data-testid={`${testid}-google`}>Google</a>
      <a className={cls} href={icsUrl} data-testid={`${testid}-outlook`}>Outlook</a>
    </div>
  );
};
